import { Button, Group, Loader, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { useState } from 'react';
import { PiClockCounterClockwise } from 'react-icons/pi';
import { DocumentCard } from '@/components/InvoiceDetailsModal/DocumentCard';
import { type TDocumentKind, useDocumentActivity } from '@/models/invoices';

const TONE: Record<string, string | undefined> = {
  ok: 'teal',
  warn: 'orange',
  error: 'red',
};

const SHOWN = 8;

/**
 * What happened to the document, newest first (spec 9.4): state changes, payments, client
 * reports added and removed, deliveries including failed and queued ones, versions, the final
 * invoice, Monday.
 */
export function ActivityCard({
  kind,
  id,
}: {
  kind: TDocumentKind;
  id: number;
}) {
  const q = useDocumentActivity(kind, id);
  const [all, setAll] = useState(false);
  const events = q.data ?? [];
  const list = all ? events : events.slice(0, SHOWN);
  return (
    <DocumentCard
      title="Activity"
      icon={<PiClockCounterClockwise size={14} />}
      extra={
        <Text fz="xs" c="dimmed">
          {events.length} events
        </Text>
      }
    >
      {q.isLoading && <Loader size="xs" />}
      <Stack gap={6}>
        {list.map((e) => (
          <Group key={e.key} gap={8} wrap="nowrap" align="flex-start">
            <Text fz={11} c="dimmed" w={78} style={{ flexShrink: 0 }}>
              {dayjs(e.at).format('DD.MM.YY HH:mm')}
            </Text>
            <Stack gap={0} style={{ minWidth: 0 }}>
              <Text fz="xs" c={e.tone ? TONE[e.tone] : undefined} fw={500}>
                {e.title}
              </Text>
              {(e.detail || e.actor) && (
                <Text fz={11} c="dimmed" style={{ wordBreak: 'break-word' }}>
                  {[e.detail, e.actor].filter(Boolean).join(' · ')}
                </Text>
              )}
            </Stack>
          </Group>
        ))}
        {events.length > SHOWN && (
          <Button
            size="compact-xs"
            variant="subtle"
            onClick={() => setAll((a) => !a)}
          >
            {all ? 'Show fewer' : `Show all ${events.length}`}
          </Button>
        )}
      </Stack>
    </DocumentCard>
  );
}
